import dayjs, { type Dayjs } from "dayjs";

import { CHAT_BUCKETS, type ChatBucket } from "./constants";

/** Counts calendar days, so a chat from 23:59 last night is already "yesterday". */
export const getChatBucket = (
  updatedAt: string,
  now: Dayjs = dayjs()
): ChatBucket => {
  const daysAgo = now
    .startOf("day")
    .diff(dayjs(updatedAt).startOf("day"), "day");

  // An unparsable date gives NaN, which fits no bucket, so it lands in "older".
  return (
    CHAT_BUCKETS.find(({ maxDaysAgo }) => daysAgo <= maxDaysAgo)?.key ?? "older"
  );
};

/**
 * Groups by bucket key in display order instead of by consecutive runs, so a
 * list that is not sorted newest first never repeats a heading.
 */
export const groupChatsByBucket = <T extends { bucket: ChatBucket }>(
  chats: readonly T[]
) =>
  CHAT_BUCKETS.map(({ key, label }) => ({
    bucket: key,
    label,
    chats: chats.filter((chat) => chat.bucket === key)
  })).filter((group) => group.chats.length > 0);
